module.exports = __webpack_public_path__ + "img/undraw_sweet_home_dkhr.96a1cd2f.svg";